import { v4 as uuidv4 } from 'uuid';

const getCookie = (name) => {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
    ?.split('=')[1] || null;
};

const getEventSession = () => {
  const ID_KEY = 'meta_vc_event_id';
  const URL_KEY = 'meta_vc_event_url';

  const cachedId = sessionStorage.getItem(ID_KEY);
  const cachedUrl = sessionStorage.getItem(URL_KEY);
  const currentUrl = window.location.href;

  const isRefresh = !!(cachedId && cachedUrl === currentUrl);

  let eventId;

  if (isRefresh) {
    eventId = cachedId;
  } else {
    eventId = uuidv4();
    sessionStorage.setItem(ID_KEY, eventId);
    sessionStorage.setItem(URL_KEY, currentUrl);
  }

  return { eventId, isRefresh };
};

export const getTrackingMetadata = () => {
  const { eventId, isRefresh } = getEventSession();

  return {
    event_id: eventId,
    is_refresh: isRefresh,
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    source_url: window.location.href,
    event_time: Math.floor(Date.now() / 1000),
  };
};


export const getManualTrackingMetadata = () => {
  return {
    event_id: uuidv4(),
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    source_url: window.location.href,
    unix_timestamp: Math.floor(Date.now() / 1000)
  };
};